import { UserController } from '../../controllers';
import { appStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import { ForgotPassword } from '../../pages';
import constant from '../../utils/constant';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import React from 'react';

const ForgetPasswordContainer = () => {
	const {
		appStore: { loading },
	} = useStores();

	const navigate = useNavigate();

	const validationSchema = translations =>
		yup.object({
			email: yup.string().required('Email is required'),
		});

	const switchToSignup = () => {
		navigate(constant.Routes.SignUp);
	};

	const switchToLogin = () => {
		navigate(constant.Routes.Login);
	};

	const onSubmit = async values => {
		appStore.setLoading(true);
		const { status, errorMessage } = await UserController.forgotPassword(
			values.email
		);
		appStore.setLoading(false);
		if (status === constant.Success) {
			localStorage.setItem(
				constant.RouteParams,
				JSON.stringify({
					OtpType: constant.OtpType.FORGETPASSWORD,
					email: values.email,
				})
			);
			return navigate(constant.Routes.Otp, {
				OtpType: constant.OtpType.FORGETPASSWORD,
				email: values.email,
			});
		}

		MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<div>
			<ForgotPassword
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				loading={loading}
				switchToSignup={switchToSignup}
				switchToLogin={switchToLogin}
			/>
		</div>
	);
};

export default observer(ForgetPasswordContainer);
